import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FileText, Printer } from 'lucide-react';
import { useAuthStore } from '../../store/useStore';
import { refertiProdottiAPI } from '../../services/refertiProdottiApi';
import api from '../../services/api';

/**
 * «Scrivi il referto da questa scheda»: la porta del generatore che
 * esiste dal 20 settembre 2026 (referto con i valori della scheda
 * copiati dentro) e che fino al 21 non si poteva aprire da nessuna
 * parte - provato, nel manuale, senza un pulsante. Sta accanto a «Salva
 * la scheda», che e' dove uno ha appena finito di compilare e pensa
 * «adesso il referto».
 *
 * Lo vede chi e' collegato a un medico: l'autore di un referto e' un
 * medico, e per la segreteria il server chiede comunque chi firma.
 * Il titolo lo propone il server (il nome della scheda) e si cambia
 * nell'editor: un prompt in piu' qui sarebbe un clic senza informazione.
 */
const BottoneRefertoDaScheda = ({ compilazioneId, disabilitato = false }) => {
    const utente = useAuthStore((s) => s.user);
    const navigate = useNavigate();
    const [inCorso, setInCorso] = useState(false);
    const [errore, setErrore] = useState(null);

    /* La STAMPA della scheda: consultazione, non documento firmato - si
       rigenera ogni volta e lo dice in testa. La vede chiunque possa
       aprire la scheda; il server rifiuta le procedure riservate. */
    const stampa = async () => {
        setErrore(null);
        try {
            const x = await api.get(`/schede/compilazione-pdf/${compilazioneId}`, { responseType: 'blob' });
            const url = window.URL.createObjectURL(new Blob([x.data], { type: 'application/pdf' }));
            window.open(url, '_blank');
            setTimeout(() => window.URL.revokeObjectURL(url), 30000);
        } catch (e) {
            setErrore('Errore nella stampa della scheda');
        }
    };

    if (!compilazioneId) return null;
    if (!utente?.medico_id) {
        return (
            <span className="sp-strumenti">
                {errore && <span className="sp-errore-inline">{errore}</span>}
                <button type="button" className="sp-referto" onClick={stampa} disabled={disabilitato}
                        title="Stampa di consultazione: non è un documento firmato">
                    <Printer size={14} strokeWidth={1.8} aria-hidden="true" /> Stampa la scheda
                </button>
            </span>
        );
    }

    const genera = async () => {
        setInCorso(true);
        setErrore(null);
        try {
            const r = await refertiProdottiAPI.daCompilazione(compilazioneId, {});
            navigate(`/referti/${r.data.data.referto.id}`);
        } catch (e) {
            setErrore(e?.response?.data?.message || e?.message || 'Errore nella generazione del referto');
            setInCorso(false);
        }
    };

    return (
        <span className="sp-strumenti">
            {errore && <span className="sp-errore-inline">{errore}</span>}
            <button type="button" className="sp-referto" onClick={stampa} disabled={disabilitato}
                    title="Stampa di consultazione: non è un documento firmato. Per un documento con valore, il referto.">
                <Printer size={14} strokeWidth={1.8} aria-hidden="true" /> Stampa la scheda
            </button>
            <button type="button" className="sp-referto" onClick={genera}
                    disabled={inCorso || disabilitato}
                    title="Crea un referto con i valori di questa scheda copiati dentro">
                <FileText size={14} strokeWidth={1.8} aria-hidden="true" />
                {inCorso ? 'Creo il referto…' : 'Scrivi il referto da questa scheda'}
            </button>
        </span>
    );
};

export default BottoneRefertoDaScheda;
